import { type FC } from "react";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import { useIssueContractPaymentInvoiceMutation } from "@/admin/entities/billing";
import {
  getErrorMessage,
  getGraphQLErrorCode,
} from "@/shared/utils/errorCodes";

interface IssueInvoiceButtonProps {
  paymentId: string;
  /** Зовётся после успешной мутации: карточка платежа перезапрашивает себя и список. */
  onCompleted?: () => void;
}

/**
 * «Выставить инвойс» (спека §5): условия видимости (pending и нет счёта)
 * проверяет вызывающий компонент, кнопка только шлёт мутацию. Причина
 * невозможности выставить (не заполнены реквизиты продавца или нет
 * банковской строки под валюту) приходит своим кодом ошибки.
 */
export const IssueInvoiceButton: FC<IssueInvoiceButtonProps> = ({
  paymentId,
  onCompleted,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [issueInvoice, { loading }] = useIssueContractPaymentInvoiceMutation({
    onCompleted: () => {
      enqueueSnackbar("Счёт выставлен", { variant: "success" });
      onCompleted?.();
    },
    onError: (error) => {
      enqueueSnackbar(
        getErrorMessage(getGraphQLErrorCode(error), error.message),
        { variant: "error" }
      );
    },
  });

  return (
    <Button
      size="small"
      variant="contained"
      disabled={loading}
      onClick={(event) => {
        event.stopPropagation();
        void issueInvoice({ variables: { id: paymentId } });
      }}
    >
      Выставить инвойс
    </Button>
  );
};
